export default "__VITE_ASSET__BmIelXEE__"